/** @type {Record<UserWebApi.SubscriptionPlan, boolean>} */
const VALID_SUBSCRIPTION_PLANS = {
    STANDARD: true,
    FAMILY_OLD: false,
    MILITARY: true,
    STUDENT: true,
    FRIEND: false,
    FAMILY: true,
    FIRST_RESPONDER: true,
};

/** @type {Record<UserWebApi.SubscriptionType, boolean>} */
const VALID_SUBSCRIPTION_TYPES = {
    BASIC: false,
    INTRO: false,
    PREMIUM: true,
    PREMIUM_MID: true,
    PREMIUM_PLUS: true,
    PROFESSIONAL: false,
};

/** @type {UserWebApi.SubscriptionPlan[]} */
const US_ONLY_SUBSCRIPTION_PLANS = ['MILITARY', 'FIRST_RESPONDER'];

export const FREE_TIER_COUNTRIES = ['US'];

export const BLOCKED_COUNTRIES = ['TR', 'PK'];

/**
 * @param {UserWebApi.SubscriptionPlan} plan
 * @return {boolean}
 */
export function isValidPlan(plan) {
    return VALID_SUBSCRIPTION_PLANS[plan] || false;
}

/**
 * Returns true if given plan type is US-specific.
 *
 * @param {UserWebApi.SubscriptionPlan} type
 * @return {boolean}
 */
export function isUsOnlyPlan(type) {
    return US_ONLY_SUBSCRIPTION_PLANS.includes(type);
}

/**
 * @param {UserWebApi.SubscriptionType} type
 * @return {boolean}
 */
export function isValidSubscriptionType(type) {
    return VALID_SUBSCRIPTION_TYPES[type];
}
